import React, { Component, Fragment } from 'react';
import b from 'b_';
import { inject, observer } from 'mobx-react';
import { ModalMode } from '../../../stores/Policy/PolicyModalStore';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import StatefulBulkEditor, { BULK_EDITOR_STATE } from '../../BulkEditor/StatefulBulkEditor';
import Card from '../../Fuse/Card';
import { FTBody, FTLabel } from '../../Fuse';
import FuseAlert from '../../FuseControls/FuseAlert';
import FuseCheckbox from '../../FuseControls/FuseCheckbox';
import FuseReadOnlyTextfield from '../../FuseControls/FuseReadOnlyTextfield';
import Pill, { PILL } from '../../Pill/Pill';
import PolicyModal from '../PolicyModal';
import SnackStore from '../../../stores/SnackStore';
import PolicyModalHeaderLayout from '../PolicyModalHeaderLayout';
import ConsoleStore from '../../../stores/ConsoleStore';
import { ROLE_READ_ONLY } from '../../../stores/Administrators/AdministratorModalStore';
import './CustomCategoriesModal.css';

const block = b.lock('CustomCategoriesModal');

class CustomCategoriesModal extends Component {
    static propTypes = {
        console: ConsoleStore.PropType,
        snack: SnackStore.PropType.isRequired,
        policy: PolicyStore.PropType.isRequired,
    };

    componentWillMount() {
        const { policy } = this.props;

        if ([ModalMode.VIEW, ModalMode.DELETE].indexOf(policy.customCategories.policyTable.policyModal.mode) > -1) {
            policy.contentRules.policyTable.load();
        }
    }

    bulkOptions = () => {
        const { policyModal } = this.props.policy.customCategories.policyTable;
        const { urlList } = policyModal.sections;

        switch (policyModal.mode) {
        case ModalMode.DELETE:
        case ModalMode.VIEW:
            return { type: BULK_EDITOR_STATE.READ_ONLY };
        case ModalMode.EDIT_CONFIRM:
            return {
                type: BULK_EDITOR_STATE.EDIT_CONFIRM,
                oldItems: policyModal.originalValue ? policyModal.originalValue.categoryIpAndUrlPatterns : [],
                newItems: policyModal.sections.urlList.store.getValue(),
                removedItemsSearch: urlList.editConfirmRemovedSearch,
                addedItemsSearch: urlList.editConfirmAddedSearch,
            };
        default:
            return {
                type: BULK_EDITOR_STATE.NORMAL,
                required: true,
                warningMessage: 'Duplicate IPs and URL Patterns will be deleted on save'
            };
        }
    };

    referencedSection(arr, label, ruleType) {
        arr = arr || [];
        ruleType = ruleType || label.toLowerCase();
        return <div>
            <FTLabel className={block('PillLabel')}>{(label)}</FTLabel>
            {arr.length === 0 ? <FTBody>No {ruleType} referenced</FTBody> : null}
            {arr.length > 0 ?
                <div className={block('PillContainer')}>
                    {arr.map((ruleName, i) => <Pill
                        className={block('Pill')}
                        type={PILL.GRAY}
                        key={i}
                    >{ruleName}</Pill>)}
                </div>
                : null}
        </div>;
    }

    references = () => {
        const { console } = this.props;
        const category = this.props.policy.customCategories.policyTable.policyModal.getValue();
        const referencedRules = category.referencedRules || {};

        return <Fragment>
            {this.referencedSection(referencedRules.ExclusionRule, 'Exclusion Rules')}
            {this.referencedSection(referencedRules.RedirectRule, 'Redirect Rules')}
            {this.referencedSection(referencedRules.ContentRule, 'Content Rules')}
            {console.isFTREnabled()
                ? this.referencedSection(referencedRules.FileThreatRule, 'File Threat Rules')
                : null}
            {console.isDLPEnabled()
                ? this.referencedSection(referencedRules.DLPRule, 'DLP Rules', 'DLP rules')
                : null}
        </Fragment>;
    };

    referencedRulesView = () => <Card title={'Referenced Rules'}>
        {this.references()}
    </Card>;

    referencedRulesDeleteConfirm = (store) => <FuseAlert
        title={'Delete Confirmation'}
        type={'danger'}
    >
        <FTBody>
            Custom categories cannot be restored once deleted.
            This custom category will be removed from all referenced rules.
        </FTBody>
        {this.references()}
        <FuseCheckbox
            black
            store={store}
            className={block('ConfirmDeleteCheckbox')}
            label={'Confirm the deletion of this custom category'}
        />
    </FuseAlert>;


    renderHeader = () => {
        const { policyModal } = this.props.policy.customCategories.policyTable;
        const store = policyModal.header;
        const readOnly = policyModal.mode === ModalMode.VIEW || policyModal.mode === ModalMode.DELETE;

        return <PolicyModalHeaderLayout
            title="Summary"
            readOnly={readOnly}
        >
            <FuseReadOnlyTextfield
                className={block('TextField', { readOnly })}
                label={'Name'}
                store={store.name}
                placeholder={'Enter Category name'}
                error={!store.name.isValid && store.name.isTouched}
                onBlur={store.onNameFieldFocusChange}
                showRequired={!readOnly}
                required={!readOnly}
                qa="entity-name"
            />

            <FuseReadOnlyTextfield
                className={block('TextField', { readOnly })}
                label={'Description'}
                store={store.description}
                defaultValue={'—'}
                placeholder={'Enter Category description'}
                qa="entity-description"
            />
        </PolicyModalHeaderLayout>;
    };

    render() {
        const { console, policy } = this.props;
        const { policyModal } = policy.customCategories.policyTable;
        const editConfirm = policyModal.mode === ModalMode.EDIT_CONFIRM;
        const readOnly = [ModalMode.VIEW, ModalMode.DELETE].indexOf(policyModal.mode) > -1 ||
            console.authority === ROLE_READ_ONLY.value;

        return <PolicyModal
            titleItemName="Custom Category"
            itemName="Category"
            store={policyModal}
            readOnly={console.authority === ROLE_READ_ONLY.value}
            confirmDeleteMessage={this.referencedRulesDeleteConfirm}
        >
            {!editConfirm
                ? this.renderHeader()
                : null
            }
            <StatefulBulkEditor
                mode={this.bulkOptions()}
                store={policyModal.sections.urlList.store}
                footerText={!readOnly ? 'At least one valid IP Address or URL is required.' : null}
            />
            {policyModal.mode === ModalMode.VIEW ? this.referencedRulesView() : null}
        </PolicyModal>;
    }
}

export default inject('console', 'snack', 'policy')(observer(CustomCategoriesModal));
